<template>
  <el-dialog :visible.sync="isTeach" width="320px" :before-close="close">
    <div class="block techer">
      <el-carousel trigger="hover" indicator-position="outside">
        <el-carousel-item v-for="item in 4" :key="item">
          <img :src="'../../static/img/en/en_sst' + item + '.png'" v-if="$i18n.locale =='en'">
          <img :src="'../../static/img/zh/sst' + item + '.png'" v-else>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="isTeach = true">打开内层 Dialog</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
  export default {
    props: {
      isTeach: {
        type: Boolean
      }
    },
    data() {
      return {

      }
    },
    methods: {
      close() {
        // this.isTeach = false;
        this.$emit('closeTeach');
      }
    }
  }

</script>
<style scoped>
  div>>>.el-dialog {
    border-radius: 10px;
  }

  div>>>.el-dialog .el-dialog__header {
    background-color: #01B5FF;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  div>>>.el-dialog__headerbtn {
    top: 8px;
  }

  div>>>.el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  div>>>.el-dialog__body {
    padding: 0px;
  }

  div>>>.el-carousel__item img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dialogteach.vue